import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { getSeeAllBI } from '../../helpers';
import s from './SeeAllLink.scss';
var SeeAllLink = function (_a) {
    var contentType = _a.contentType, deviation = _a.deviation, type = _a.type, url = _a.url, className = _a.className, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(TextButton, { className: classnames(s['root'], className), variant: "main", size: "small", href: url, onClick: onClick, biData: getSeeAllBI(contentType, deviation) }, t(["sidebar.".concat(type, ".").concat(contentType), "sidebar.".concat(type)])));
};
SeeAllLink.displayName = 'SeeAllLink';
export default SeeAllLink;
//# sourceMappingURL=SeeAllLink.js.map